module.exports = __webpack_public_path__ + "img/SL-M-160-240.d1609864.svg";